(function($) {

	$.fn.initNumberSpinner = function(options) {

		options = $.extend({
			"onChange": null
		}, options);

		return this.each(function() {

			var $this = $(this);
			$this.click(function() {
				var $target = $( $this.attr("data-target") );
				$target.val(
					parseFloat( $target.val()) + parseFloat( $this.attr("data-value") )
				);

				if ($target.attr("min") && $target.val() < parseFloat($target.attr("min"))) {
					$target.val($target.attr("min"));
				}

				if (options.onChange) {
					options.onChange.call(this);
				}

				return false;
			});

		});

	};

})(jQuery);